import { Text } from "@gcs/design-system/react";
import styled from "styled-components/macro";

export const ModalContainer = styled.div(({ theme }) => ({
  width: "90%",
  margin: "auto",
  padding: "40px",
  background: theme.color.neutral["08"],
  position: "absolute",
  zIndex: 9999,
  left: "5%",
  top: "50%",
  [theme.breakpoint.xl()]: {
    top: "100px",
    left: "unset",
    position: "fixed",
    padding: "40px 50px 100px 50px",
    width: "65%",
  },
}));

export const TitleContainer = styled(Text)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
  fontSize: "24px",
  [theme.breakpoint.xl()]: {
    fontSize: "28px",
    marginBottom: "50px",
  },
}));

export const Content = styled.div(({ theme }) => ({
  fontWeight: "500",
  fontSize: "18px",
  lineHeight: "150%",
}));
